import * as React from 'react';

import { Link } from '@/components/common';
import PrimaryButton from '@/components/display/buttons/primary-button';
import SecondaryButton from '@/components/display/buttons/secondary-button';

type UpcomingEventProps = {
    title: string;
    description: string;
    location: string;
    date: string;
    learnMoreUrl: string;
    registerUrl: string;
    className?: string;
};

const UpcomingEvent = (props: UpcomingEventProps) => {
    const { className, title, description, location, date, learnMoreUrl, registerUrl } = props;

    return (
        <div className={className}>
            <div className="flex flex-col justify-start items-start gap-4 p-10">
                <div className="flex flex-col justify-start items-start gap-1">
                    <div className="flex justify-start items-start relative">
                        <p className="flex-grow text-2xl text-left font-semibold text-dark hover:text-gray-800">
                            <Link href={learnMoreUrl}>{title}</Link>
                        </p>
                    </div>
                    <div className="flex flex-col justify-start relative text-gray-700">
                        <div className="flex justify-start items-center relative gap-1 text-gray-700">
                            <svg
                                width="8"
                                height="10"
                                viewBox="0 0 8 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.65685 6.65685C6.03287 7.28084 4.31371 9 4.31371 9C4.31371 9 2.64066 7.32695 1.97056 6.65685C0.676479 5.36277 0.676479 3.26465 1.97056 1.97056C3.26465 0.676479 5.36277 0.676479 6.65685 1.97056C7.95094 3.26465 7.95094 5.36277 6.65685 6.65685Z"
                                    stroke="#111827"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.55635 4.31371C5.55635 5 5 5.55635 4.31371 5.55635C3.62742 5.55635 3.07107 5 3.07107 4.31371C3.07107 3.62742 3.62742 3.07107 4.31371 3.07107C5 3.07107 5.55635 3.62742 5.55635 4.31371Z"
                                    stroke="#111827"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <span className="flex justify-start items-center relative text-sm text-left uppercase whitespace-nowrap">
                                {location}
                            </span>
                        </div>
                        <div className="flex justify-start items-center relative gap-1">
                            <svg
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="flex-grow-0 flex-shrink-0"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path
                                    d="M2.84918 2.77778V1M6.40473 2.77778V1M2.40473 4.55556H6.84918M1.51584 9H7.73806C8.22898 9 8.62695 8.60203 8.62695 8.11111V2.77778C8.62695 2.28686 8.22898 1.88889 7.73806 1.88889H1.51584C1.02492 1.88889 0.626953 2.28686 0.626953 2.77778V8.11111C0.626953 8.60203 1.02492 9 1.51584 9Z"
                                    stroke="#110B29"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="flex justify-start items-center relative gap-1">
                                <p className="text-sm text-left uppercase">{date}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-start items-start self-stretch relative gap-2.5">
                    <p className="flex-grow text-base text-left text-[#6a6a6a]">{description}</p>
                </div>
                <div className="flex flex-wrap justify-start items-start self-stretch gap-3">
                    {registerUrl && (
                        <PrimaryButton link={registerUrl} className="uppercase">
                            buy tickets
                        </PrimaryButton>
                    )}
                    {learnMoreUrl && (
                        <SecondaryButton link={learnMoreUrl} className="uppercase">
                            learn more
                        </SecondaryButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UpcomingEvent;
